import { CountryOption } from '@/types/user';

export const countries: CountryOption[] = [
  { code: "US", name: "United States", dial_code: "+1", flag: "🇺🇸" },
  { code: "GB", name: "United Kingdom", dial_code: "+44", flag: "🇬🇧" },
  { code: "CA", name: "Canada", dial_code: "+1", flag: "🇨🇦" },
  { code: "AU", name: "Australia", dial_code: "+61", flag: "🇦🇺" },
  { code: "DE", name: "Germany", dial_code: "+49", flag: "🇩🇪" },
  { code: "FR", name: "France", dial_code: "+33", flag: "🇫🇷" },
  { code: "ES", name: "Spain", dial_code: "+34", flag: "🇪🇸" },
  { code: "IT", name: "Italy", dial_code: "+39", flag: "🇮🇹" },
  { code: "JP", name: "Japan", dial_code: "+81", flag: "🇯🇵" },
  { code: "CN", name: "China", dial_code: "+86", flag: "🇨🇳" },
  { code: "IN", name: "India", dial_code: "+91", flag: "🇮🇳" },
  { code: "BR", name: "Brazil", dial_code: "+55", flag: "🇧🇷" },
  { code: "MX", name: "Mexico", dial_code: "+52", flag: "🇲🇽" },
  { code: "RU", name: "Russia", dial_code: "+7", flag: "🇷🇺" },
  { code: "ZA", name: "South Africa", dial_code: "+27", flag: "🇿🇦" },
  { code: "KR", name: "South Korea", dial_code: "+82", flag: "🇰🇷" },
  { code: "SG", name: "Singapore", dial_code: "+65", flag: "🇸🇬" },
  { code: "NL", name: "Netherlands", dial_code: "+31", flag: "🇳🇱" },
  { code: "SE", name: "Sweden", dial_code: "+46", flag: "🇸🇪" },
  { code: "NO", name: "Norway", dial_code: "+47", flag: "🇳🇴" },
  { code: "DK", name: "Denmark", dial_code: "+45", flag: "🇩🇰" },
  { code: "FI", name: "Finland", dial_code: "+358", flag: "🇫🇮" },
  { code: "CH", name: "Switzerland", dial_code: "+41", flag: "🇨🇭" },
  { code: "NZ", name: "New Zealand", dial_code: "+64", flag: "🇳🇿" },
  { code: "IE", name: "Ireland", dial_code: "+353", flag: "🇮🇪" },
  { code: "BE", name: "Belgium", dial_code: "+32", flag: "🇧🇪" },
  { code: "PT", name: "Portugal", dial_code: "+351", flag: "🇵🇹" },
  { code: "GR", name: "Greece", dial_code: "+30", flag: "🇬🇷" },
  { code: "AT", name: "Austria", dial_code: "+43", flag: "🇦🇹" },
  { code: "PL", name: "Poland", dial_code: "+48", flag: "🇵🇱" },
  { code: "TR", name: "Turkey", dial_code: "+90", flag: "🇹🇷" },
  { code: "AE", name: "United Arab Emirates", dial_code: "+971", flag: "🇦🇪" },
  { code: "SA", name: "Saudi Arabia", dial_code: "+966", flag: "🇸🇦" },
  { code: "TH", name: "Thailand", dial_code: "+66", flag: "🇹🇭" },
  { code: "MY", name: "Malaysia", dial_code: "+60", flag: "🇲🇾" },
  { code: "ID", name: "Indonesia", dial_code: "+62", flag: "🇮🇩" },
  { code: "PH", name: "Philippines", dial_code: "+63", flag: "🇵🇭" },
  { code: "VN", name: "Vietnam", dial_code: "+84", flag: "🇻🇳" },
  { code: "AR", name: "Argentina", dial_code: "+54", flag: "🇦🇷" },
  { code: "CL", name: "Chile", dial_code: "+56", flag: "🇨🇱" },
  { code: "CO", name: "Colombia", dial_code: "+57", flag: "🇨🇴" },
  { code: "PE", name: "Peru", dial_code: "+51", flag: "🇵🇪" },
  { code: "VE", name: "Venezuela", dial_code: "+58", flag: "🇻🇪" },
  { code: "EG", name: "Egypt", dial_code: "+20", flag: "🇪🇬" },
  { code: "NG", name: "Nigeria", dial_code: "+234", flag: "🇳🇬" },
  { code: "KE", name: "Kenya", dial_code: "+254", flag: "🇰🇪" },
  { code: "MA", name: "Morocco", dial_code: "+212", flag: "🇲🇦" },
  { code: "IL", name: "Israel", dial_code: "+972", flag: "🇮🇱" },
  { code: "UA", name: "Ukraine", dial_code: "+380", flag: "🇺🇦" },
  { code: "HU", name: "Hungary", dial_code: "+36", flag: "🇭🇺" },
  { code: "CZ", name: "Czech Republic", dial_code: "+420", flag: "🇨🇿" },
  { code: "RO", name: "Romania", dial_code: "+40", flag: "🇷🇴" },
  { code: "BG", name: "Bulgaria", dial_code: "+359", flag: "🇧🇬" },
  { code: "HR", name: "Croatia", dial_code: "+385", flag: "🇭🇷" },
  { code: "RS", name: "Serbia", dial_code: "+381", flag: "🇷🇸" },
  { code: "SK", name: "Slovakia", dial_code: "+421", flag: "🇸🇰" },
  { code: "SI", name: "Slovenia", dial_code: "+386", flag: "🇸🇮" },
  { code: "LT", name: "Lithuania", dial_code: "+370", flag: "🇱🇹" },
  { code: "LV", name: "Latvia", dial_code: "+371", flag: "🇱🇻" },
  { code: "EE", name: "Estonia", dial_code: "+372", flag: "🇪🇪" },
  { code: "IS", name: "Iceland", dial_code: "+354", flag: "🇮🇸" },
  { code: "LU", name: "Luxembourg", dial_code: "+352", flag: "🇱🇺" },
  { code: "MT", name: "Malta", dial_code: "+356", flag: "🇲🇹" },
  { code: "CY", name: "Cyprus", dial_code: "+357", flag: "🇨🇾" },
  { code: "LI", name: "Liechtenstein", dial_code: "+423", flag: "🇱🇮" },
  { code: "MC", name: "Monaco", dial_code: "+377", flag: "🇲🇨" },
  { code: "SM", name: "San Marino", dial_code: "+378", flag: "🇸🇲" },
  { code: "VA", name: "Vatican City", dial_code: "+379", flag: "🇻🇦" },
  { code: "AD", name: "Andorra", dial_code: "+376", flag: "🇦🇩" },
  { code: "AL", name: "Albania", dial_code: "+355", flag: "🇦🇱" },
  { code: "BA", name: "Bosnia and Herzegovina", dial_code: "+387", flag: "🇧🇦" },
  { code: "BY", name: "Belarus", dial_code: "+375", flag: "🇧🇾" },
  { code: "GE", name: "Georgia", dial_code: "+995", flag: "🇬🇪" },
  { code: "MD", name: "Moldova", dial_code: "+373", flag: "🇲🇩" },
  { code: "MK", name: "North Macedonia", dial_code: "+389", flag: "🇲🇰" },
  { code: "ME", name: "Montenegro", dial_code: "+382", flag: "🇲🇪" },
  { code: "AM", name: "Armenia", dial_code: "+374", flag: "🇦🇲" },
  { code: "AZ", name: "Azerbaijan", dial_code: "+994", flag: "🇦🇿" },
  { code: "KZ", name: "Kazakhstan", dial_code: "+7", flag: "🇰🇿" },
  { code: "KG", name: "Kyrgyzstan", dial_code: "+996", flag: "🇰🇬" },
  { code: "TJ", name: "Tajikistan", dial_code: "+992", flag: "🇹🇯" },
  { code: "TM", name: "Turkmenistan", dial_code: "+993", flag: "🇹🇲" },
  { code: "UZ", name: "Uzbekistan", dial_code: "+998", flag: "🇺🇿" },
  { code: "MN", name: "Mongolia", dial_code: "+976", flag: "🇲🇳" },
  { code: "BT", name: "Bhutan", dial_code: "+975", flag: "🇧🇹" },
  { code: "NP", name: "Nepal", dial_code: "+977", flag: "🇳🇵" },
  { code: "LK", name: "Sri Lanka", dial_code: "+94", flag: "🇱🇰" },
  { code: "BD", name: "Bangladesh", dial_code: "+880", flag: "🇧🇩" },
  { code: "MV", name: "Maldives", dial_code: "+960", flag: "🇲🇻" },
  { code: "BN", name: "Brunei", dial_code: "+673", flag: "🇧🇳" },
  { code: "LA", name: "Laos", dial_code: "+856", flag: "🇱🇦" },
  { code: "KH", name: "Cambodia", dial_code: "+855", flag: "🇰🇭" },
  { code: "MM", name: "Myanmar", dial_code: "+95", flag: "🇲🇲" },
  { code: "TL", name: "Timor-Leste", dial_code: "+670", flag: "🇹🇱" },
  { code: "PG", name: "Papua New Guinea", dial_code: "+675", flag: "🇵🇬" },
  { code: "FJ", name: "Fiji", dial_code: "+679", flag: "🇫🇯" },
  { code: "SB", name: "Solomon Islands", dial_code: "+677", flag: "🇸🇧" },
  { code: "VU", name: "Vanuatu", dial_code: "+678", flag: "🇻🇺" },
  { code: "WS", name: "Samoa", dial_code: "+685", flag: "🇼🇸" },
  { code: "TO", name: "Tonga", dial_code: "+676", flag: "🇹🇴" },
  { code: "KI", name: "Kiribati", dial_code: "+686", flag: "🇰🇮" },
  { code: "FM", name: "Micronesia", dial_code: "+691", flag: "🇫🇲" },
  { code: "MH", name: "Marshall Islands", dial_code: "+692", flag: "🇲🇭" },
  { code: "PW", name: "Palau", dial_code: "+680", flag: "🇵🇼" },
  { code: "NR", name: "Nauru", dial_code: "+674", flag: "🇳🇷" },
  { code: "TV", name: "Tuvalu", dial_code: "+688", flag: "🇹🇻" },
  { code: "CK", name: "Cook Islands", dial_code: "+682", flag: "🇨🇰" },
  { code: "NU", name: "Niue", dial_code: "+683", flag: "🇳🇺" },
  { code: "TK", name: "Tokelau", dial_code: "+690", flag: "🇹🇰" },
  { code: "PF", name: "French Polynesia", dial_code: "+689", flag: "🇵🇫" },
  { code: "NC", name: "New Caledonia", dial_code: "+687", flag: "🇳🇨" },
  { code: "WF", name: "Wallis and Futuna", dial_code: "+681", flag: "🇼🇫" },
  { code: "AS", name: "American Samoa", dial_code: "+1", flag: "🇦🇸" },
  { code: "GU", name: "Guam", dial_code: "+1", flag: "🇬🇺" },
  { code: "MP", name: "Northern Mariana Islands", dial_code: "+1", flag: "🇲🇵" },
  { code: "PR", name: "Puerto Rico", dial_code: "+1", flag: "🇵🇷" },
  { code: "VI", name: "U.S. Virgin Islands", dial_code: "+1", flag: "🇻🇮" },
  { code: "GI", name: "Gibraltar", dial_code: "+350", flag: "🇬🇮" },
  { code: "GL", name: "Greenland", dial_code: "+299", flag: "🇬🇱" },
  { code: "FO", name: "Faroe Islands", dial_code: "+298", flag: "🇫🇴" },
  { code: "AX", name: "Åland Islands", dial_code: "+358", flag: "🇦🇽" },
  { code: "PM", name: "Saint Pierre and Miquelon", dial_code: "+508", flag: "🇵🇲" },
  { code: "BM", name: "Bermuda", dial_code: "+1", flag: "🇧🇲" },
  { code: "AI", name: "Anguilla", dial_code: "+1", flag: "🇦🇮" },
  { code: "AG", name: "Antigua and Barbuda", dial_code: "+1", flag: "🇦🇬" },
  { code: "BS", name: "Bahamas", dial_code: "+1", flag: "🇧🇸" },
  { code: "BB", name: "Barbados", dial_code: "+1", flag: "🇧🇧" },
  { code: "DM", name: "Dominica", dial_code: "+1", flag: "🇩🇲" },
  { code: "DO", name: "Dominican Republic", dial_code: "+1", flag: "🇩🇴" },
  { code: "GD", name: "Grenada", dial_code: "+1", flag: "🇬🇩" },
  { code: "JM", name: "Jamaica", dial_code: "+1", flag: "🇯🇲" },
  { code: "KN", name: "Saint Kitts and Nevis", dial_code: "+1", flag: "🇰🇳" },
  { code: "LC", name: "Saint Lucia", dial_code: "+1", flag: "🇱🇨" },
  { code: "VC", name: "Saint Vincent and the Grenadines", dial_code: "+1", flag: "🇻🇨" },
  { code: "TT", name: "Trinidad and Tobago", dial_code: "+1", flag: "🇹🇹" },
  { code: "TC", name: "Turks and Caicos Islands", dial_code: "+1", flag: "🇹🇨" },
  { code: "MS", name: "Montserrat", dial_code: "+1", flag: "🇲🇸" },
  { code: "KY", name: "Cayman Islands", dial_code: "+1", flag: "🇰🇾" },
  { code: "GF", name: "French Guiana", dial_code: "+594", flag: "🇬🇫" },
  { code: "GP", name: "Guadeloupe", dial_code: "+590", flag: "🇬🇵" },
  { code: "MQ", name: "Martinique", dial_code: "+596", flag: "🇲🇶" },
  { code: "BL", name: "Saint Barthélemy", dial_code: "+590", flag: "🇧🇱" },
  { code: "MF", name: "Saint Martin", dial_code: "+590", flag: "🇲🇫" },
  { code: "SX", name: "Sint Maarten", dial_code: "+1", flag: "🇸🇽" },
  { code: "CW", name: "Curaçao", dial_code: "+599", flag: "🇨🇼" },
  { code: "BQ", name: "Caribbean Netherlands", dial_code: "+599", flag: "🇧🇶" },
  { code: "AW", name: "Aruba", dial_code: "+297", flag: "🇦🇼" },
  { code: "CR", name: "Costa Rica", dial_code: "+506", flag: "🇨🇷" },
  { code: "GT", name: "Guatemala", dial_code: "+502", flag: "🇬🇹" },
  { code: "HN", name: "Honduras", dial_code: "+504", flag: "🇭🇳" },
  { code: "NI", name: "Nicaragua", dial_code: "+505", flag: "🇳🇮" },
  { code: "PA", name: "Panama", dial_code: "+507", flag: "🇵🇦" },
  { code: "SV", name: "El Salvador", dial_code: "+503", flag: "🇸🇻" },
  { code: "BZ", name: "Belize", dial_code: "+501", flag: "🇧🇿" },
  { code: "BO", name: "Bolivia", dial_code: "+591", flag: "🇧🇴" },
  { code: "EC", name: "Ecuador", dial_code: "+593", flag: "🇪🇨" },
  { code: "GY", name: "Guyana", dial_code: "+592", flag: "🇬🇾" },
  { code: "PY", name: "Paraguay", dial_code: "+595", flag: "🇵🇾" },
  { code: "SR", name: "Suriname", dial_code: "+597", flag: "🇸🇷" },
  { code: "UY", name: "Uruguay", dial_code: "+598", flag: "🇺🇾" },
  { code: "CI", name: "Côte d'Ivoire", dial_code: "+225", flag: "🇨🇮" },
  { code: "GH", name: "Ghana", dial_code: "+233", flag: "🇬🇭" },
  { code: "SN", name: "Senegal", dial_code: "+221", flag: "🇸🇳" },
  { code: "TZ", name: "Tanzania", dial_code: "+255", flag: "🇹🇿" },
  { code: "UG", name: "Uganda", dial_code: "+256", flag: "🇺🇬" },
  { code: "ZM", name: "Zambia", dial_code: "+260", flag: "🇿🇲" },
  { code: "ZW", name: "Zimbabwe", dial_code: "+263", flag: "🇿🇼" },
];

// Return countries sorted alphabetically by name
export const getSortedCountries = (): CountryOption[] => {
  return [...countries].sort((a, b) => a.name.localeCompare(b.name));
};

// Function to sort countries by dial code
export const getCountriesByDialCode = (): CountryOption[] => {
  return [...countries].sort((a, b) => {
    // First remove the + sign and convert to number for proper sorting
    const codeA = parseInt(a.dial_code.replace('+', ''), 10);
    const codeB = parseInt(b.dial_code.replace('+', ''), 10);
    return codeA - codeB;
  });
};

export const findCountryByDialCode = (dialCode: string): CountryOption | undefined => {
  return countries.find(country => country.dial_code === dialCode);
};

export const findCountryByCode = (code: string): CountryOption | undefined => {
  return countries.find(country => country.code === code);
};

// Improved search function that correctly handles multi-character queries
export const searchCountriesByName = (query: string): CountryOption[] => {
  if (!query || query.trim() === '') return getSortedCountries();
  
  const normalizedQuery = query.toLowerCase().trim();
  
  // Create filtered array with all countries that match the query
  return countries
    .filter(country => {
      // Check different ways a country could match
      const nameMatches = country.name.toLowerCase().includes(normalizedQuery);
      const codeMatches = country.code.toLowerCase().includes(normalizedQuery);
      const dialCodeMatches = country.dial_code.toLowerCase().includes(normalizedQuery.replace('+', ''));
      
      return nameMatches || codeMatches || dialCodeMatches;
    })
    .sort((a, b) => {
      const aName = a.name.toLowerCase();
      const bName = b.name.toLowerCase();
      
      // First priority: exact matches
      const aExactMatch = aName === normalizedQuery;
      const bExactMatch = bName === normalizedQuery;
      if (aExactMatch && !bExactMatch) return -1;
      if (!aExactMatch && bExactMatch) return 1;
      
      // Second priority: starts with the query
      const aStartsWith = aName.startsWith(normalizedQuery);
      const bStartsWith = bName.startsWith(normalizedQuery);
      if (aStartsWith && !bStartsWith) return -1;
      if (!aStartsWith && bStartsWith) return 1;
      
      // Third priority: contains the query
      const aContains = aName.includes(normalizedQuery);
      const bContains = bName.includes(normalizedQuery);
      if (aContains && !bContains) return -1;
      if (!aContains && bContains) return 1;
      
      // Fourth priority: alphabetical order
      return a.name.localeCompare(b.name);
    });
};

// Function to get countries sorted by name for dial code selector
export const getCountriesByNameWithDialCode = (): CountryOption[] => {
  return [...countries]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(country => ({
      ...country,
      // Save the original code as the value to select
      code: country.code,
      // But include the dial_code in the display name
      name: `${country.name} (${country.dial_code})`
    }));
};

// Helper function to check if a browser supports emoji flags
export const testFlagSupport = (): boolean => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return false;
  
  // Test with US flag emoji
  const flagEmoji = '🇺🇸';
  ctx.fillText(flagEmoji, -10, 0);
  return ctx.getImageData(0, 0, 10, 10).data[3] !== 0; // Check if anything was drawn
};

// Get country code from flag emoji
export const getCountryCodeFromFlag = (flag: string): string | null => {
  // Log for debugging
  console.log('Flag character codes:', [...flag].map(c => c.codePointAt(0)?.toString(16)));
  
  // Return null if browser doesn't seem to support flag emojis
  if (!flag || flag.length < 2) return null;
  
  // For flagged countries, find the matching one
  const matchingCountry = countries.find(c => c.flag === flag);
  return matchingCountry?.code || null;
};
